import { isString } from 'lodash-es';

import { ISODateFormat, defaultDateFormat, format, yesterday, isMatch, subDays, isAfter } from '../../../utils/date';

export const dateRangeToDisplay = (currentPeriod, dateFrom, dateTo, maxDate) => {
  if (dateFrom && dateTo) {
    const startDate = format(dateFrom);
    const endDate = isAfter(dateTo, maxDate) ? format(maxDate) : format(dateTo);
    return startDate === endDate ? endDate : `${startDate} - ${endDate}`;
  }

  return `${format(subDays(maxDate, currentPeriod - 1))} - ${format(maxDate)}`;
};

export const dateStringToDate = (dateStr) => {
  const getHoursAndMinutes = () => ([new Date().getHours(), new Date().getMinutes()]);

  if (isMatch(dateStr, defaultDateFormat)) {
    const [month, day, year] = dateStr.split('/');
    const [hours, minutes] = getHoursAndMinutes();

    return new Date(year, month - 1, day, hours, minutes);
  }

  if (isMatch(dateStr, ISODateFormat)) {
    const [year, month, day] = dateStr.split('-');
    const [hours, minutes] = getHoursAndMinutes();

    return new Date(year, month - 1, day, hours, minutes);
  }

  return null;
};

export const maxDate = (maxDateStr, unlimitedPeriod) => {
  const yesterdayDate = dateStringToDate(yesterday());

  if (!maxDateStr) return yesterdayDate;

  const maxDateTo = isString(maxDateStr) ? dateStringToDate(maxDateStr) : maxDateStr;

  if (!maxDateTo) return yesterdayDate;
  if (unlimitedPeriod) return maxDateTo;

  return yesterdayDate > maxDateTo ? maxDateTo : yesterdayDate;
};
